import styled from 'styled-components';

export const FieldBlock = styled.div<{ noAssistive: boolean }>`
  width: 100%;
  margin-bottom: ${({ noAssistive }) => (noAssistive ? '7px' : '0')};
`;
